<template>
  <router-link tag="div" :to="{name: 'recipeView', params: { id: recipe.id }}" class="recipe">
    <div class="thumb"><a href="recipe.html"><img :src="recipe.bannerUrl"></a>
      <div class="produced" v-if="recipe.madeInProject">CultureLabs pilot project</div>
    </div>
    <div class="text"> 
      <router-link :title="recipe.title" class="title" :to="{ name: 'recipeView', params: { id: recipe.id }}">
          {{ recipe.title | truncate(55, '...') }}
        </router-link>
      
      <p class="card-desc">{{ recipe.description | truncate(200, '...') }}</p><br/>
        <div class="metadata">
          <div class="creator">By <b>{{ recipe.creator.login }}</b></div>
            <div class="addbookmark" v-if="authenticatedUser && this.$store.state.user.login !== this.recipe.creator.login">
              <span class="mr-3"><b-link
                    :title="computedBookmark === false ? 'Add bookmark' : 'Remove Bookmark'"
                    v-b-tooltip.hover.top
                    v-on:click.stop="handleBookmarkRecipe(recipe)"
                  >
                      <i
                        style="color: red"
                        :class="computedBookmark ? 'fas fa-bookmark fa-lg' : 'far fa-bookmark fa-lg'"
                      ></i>
                  </b-link></span>
            </div>
          </div>
        </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'featuredRecipeCard',
  props: {
    recipe: Object
  },
  data() {
    return {
        bookmarked: undefined
      }
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    computedBookmark () {
        if (this.bookmarked !== undefined) {
          return this.bookmarked
        }
        else if (this.recipe.bookmarked){
          return this.recipe.bookmarked;
        }
        else{ return false;}
      }
  },
  methods: {
    handleBookmarkRecipe(recipe) {
      if (!this.computedBookmark) {
        var self=this;
        this.$store.dispatch("bookmarkRecipe", recipe.id).then((response) => {
          if (response.status === 200) {
            self.bookmarked = true;
          }
        });
      } else {
        var self= this;
        this.$store
          .dispatch("deleteBookmarkRecipe", recipe.id)
          .then((response) => {
            if (response.status === 200) {
              self.bookmarked = false;
            }
          });
      }
    }
  }
}
</script>

<style scoped>
.recipe-card {
  height: 260px;
}
.card-img-top {
width: 100%;
height: 180px;
object-fit: cover;
}
.card-text {
    font-size: 20px !important;
}
.card-desc{
  display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/FeaturedRecipeCard.vue